// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3zsio","icon":"SortAdornment_icon__m7sRE","up":"SortAdornment_up__2Vq-f","down":"SortAdornment_down__la1nf","active":"SortAdornment_active__1SRJX"};